export const LogoMark = ({ className = "w-9 h-9", dark = false }) => {
  const primary = dark ? "#F6F4F0" : "#1F1E1B";
  const secondary = dark ? "#8A8578" : "#9B958A";
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <rect
        width="64"
        height="64"
        rx="14"
        fill={dark ? "#1F1E1B" : "none"}
        stroke={dark ? "none" : "#1F1E1B"}
        strokeOpacity={dark ? 0 : 0.2}
        strokeWidth="1.5"
      />
      <path d="M20 48V16h12c6.6 0 10.5 3.9 10.5 10.5S38.6 37 32 37h-6v11h-6z" fill="none" stroke={primary} strokeWidth="3.2" />
      <path d="M36 37h10v11H36c-6.6 0-10.5-3.9-10.5-10.5" fill="none" stroke={secondary} strokeWidth="3.2" />
    </svg>
  );
};

export const LogoWordmark = ({ compact = false, dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark dark={dark} className={compact ? "w-8 h-8" : "w-9 h-9"} />
    <div className="leading-none">
      <span className={`block font-serif text-lg tracking-[0.08em] font-medium ${dark ? "text-[#F6F4F0]" : "text-[#1F1E1B]"}`}>
        PJG
      </span>
      <span className={`block font-sans text-[9px] tracking-[0.32em] uppercase mt-1 ${dark ? "text-[#A8A49B]" : "text-[#6E6A61]"}`}>
        Capital Partners
      </span>
    </div>
  </div>
);
